module.exports = __webpack_public_path__ + "static/img/title.ac9b438.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Rules/img/top/title.png
// module id = 509
// module chunks = 0